import React, {Component} from 'react';
import appConfig from '../../../config';

let $ = window.jQuery;
let Bloodhound = window.Bloodhound;
let Handlebars = window.Handlebars;

export default class AddressLookup extends Component {

	state = {
		addresses: [],
		street : '',
		barangay : '',
		city : '',
		province : '',
		zip_code : ''
	}

	componentWillReceiveProps(nextProps) {
		let data = nextProps.data;
		this.setState({
			street : data.street,
			barangay : data.barangay,
			city : data.city,
			province : data.province,
			zip_code : data.zip_code
		});
	}

	componentWillMount() {
		var addresses = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: appConfig.apiUrl + 'addresslookup?term=%QUERY&q=municipality',
                wildcard: '%QUERY'
            }
        });

        this.setState({addresses});
	}

	componentDidMount() {
	
		$('.address_typeahead').typeahead(null, {
            display: 'value',
          	source: this.state.addresses,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'Unable to find any address that match the current search query',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                        '<div class="media-body">',
                            '<h4 class="media-heading">{{label}}</h4>',
                            '<p>{{id}}</p>',
                        '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
        	this.selectedTypeahead(obj, datum);
 			
        	// hidden fields
            $('#add_district_name_params').val(datum.value);
            $('#add_city_name_params').val(datum.municipality);
            $('#add_province_name_params').val(datum.province);


        }).on('typeahead:active', (e) => {
            $(e.target).siblings('.form-control-focus').remove();
            $(e.target).siblings('.help-block').remove();
            $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">Address Search</span>');
        });

	}

	selectedTypeahead = (e, datum) => {
		let type = $(e.target).attr('data-type');
		let value = e.target.value;
		let cityVal = datum.municipality;
		let provinceVal = datum.province;
		let zipVal = datum.zip;
		let barangayVal = datum.value;

		switch (type) {
			case 'barangay' : 
				$($(e.target).typeahead('val',datum.value));
	            $('#add_city_name').val(datum.municipality);
	            $('#add_province_name').val(datum.province);
	            $('#add_zip_name').val(datum.zip);
				
				this.setState({elementName : value},() => {this.throwState()});
				this.setState({city : cityVal},() => {this.throwState()});
				this.setState({province : provinceVal},() => {this.throwState()});
				this.setState({zip_code : zipVal},() => {this.throwState()});

				break;
			case 'municipality' : 
				$($(e.target).typeahead('val',datum.municipality));
	            $('#add_district_name').val(datum.value);
	            $('#add_province_name').val(datum.province);
	            $('#add_zip_name').val(datum.zip);
				
	            this.setState({elementName : value},() => {this.throwState()});
				this.setState({barangay : barangayVal},() => {this.throwState()});
				this.setState({province : provinceVal},() => {this.throwState()});
				this.setState({zip_code : zipVal},() => {this.throwState()});

				break;
			case 'province' : 
				$($(e.target).typeahead('val',datum.province));
	            $('#add_district_name').val(datum.value);
	            $('#add_city_name').val(datum.municipality);
	            $('#add_zip_name').val(datum.zip);

	            this.setState({elementName : value},() => {this.throwState()});
				this.setState({barangay : barangayVal},() => {this.throwState()});
				this.setState({city : cityVal},() => {this.throwState()});
				this.setState({zip_code : zipVal},() => {this.throwState()});
				
				break;
			default:
				// Do Nothing
		}
	}

	throwState = () => {
		this.props.getState(this.state);
	}

	render() {
		return (
			<div>
				<div className="form-group">
	                <div className="row">
	                	<div className="col-md-12">
	                		<label><strong>ADDRESS</strong></label>
	                	</div>
	                </div>
	                <div className="row">
		                <div className="col-md-12">
			                <div className="form-group form-md-line-input">
			                    <input type="text" placeholder="" name="street" id="street_field" className="form-control" value={this.state.street} onChange={(e) => {this.setState({street : e.target.value},() => {this.throwState()})}} /> 
			                    <label className="control-label">Street</label>
			                </div>
		                </div>
	                </div>
                </div>
				<div className="form-group">
                    <div className="row">
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<label className="control-label">Barangay/District</label>
			                    <input type="text" placeholder="" name="barangay" id="add_district_name" className="form-control address_typeahead" data-type="barangay" value={this.state.barangay} onChange={(e) => {this.setState({barangay : e.target.value},() => {this.throwState()})}} /> 
			                    <input type="hidden" placeholder="" name="barangay" id="add_district_name_params" className="form-control" value={this.state.barangay} onChange={(e) => {this.setState({barangay : e.target.value},() => {this.throwState()})}} /> 
		                	</div>
	                	</div>
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<label className="control-label">City</label>
			                    <input type="text" placeholder="" name="city" id="add_city_name" className="form-control address_typeahead" data-type="municipality" value={this.state.city} onChange={(e) => {this.setState({city : e.target.value},() => {this.throwState()})}} /> 
			                    <input type="hidden" placeholder="" name="city" id="add_city_name_params" className="form-control" value={this.state.city} onChange={(e) => {this.setState({city : e.target.value},() => {this.throwState()})}} /> 
		                	</div>
	                	</div>
	                </div>
                </div>
                <div className="form-group">
                    <div className="row">
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<label className="control-label">Province</label>
			                    <input type="text" placeholder="" name="province" id="add_province_name" className="form-control address_typeahead" data-type="province" value={this.state.province} onChange={(e) => {this.setState({province : e.target.value},() => {this.throwState()})}} /> 
			                    <input type="hidden" placeholder="" name="province" id="add_province_name_params" className="form-control" value={this.state.province} onChange={(e) => {this.setState({province : e.target.value},() => {this.throwState()})}} /> 
		                	</div>
	                	</div>
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<label className="control-label">Zipcode</label>
			                    <input type="text" placeholder="" name="zip_code" id="add_zip_name" className="form-control" value={this.state.zip_code} onChange={(e) => {this.setState({zip_code : e.target.value},() => {this.throwState()})}} /> 
		                	</div>
	                	</div>
	                </div>
	            </div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/commons/AddressLookup/AddressLookup.js
 **/